<div class="message-popup-header">
  <div class="commerical-header">
    <img
      src="../../../../assets/images/ibc-customer-logo.svg"
      alt="ibc_logo"
      width="140" />
    <mat-divider [vertical]="true"></mat-divider>
    <span class="ibc-customer-heading-h5-light">Commercial Invoice</span>
  </div>
</div>

<div class="message-popup-content">
  <div class="commercial-invoice-container">
    <div class="invoice-details-container">
      @for (
        invoice of invoiceDetails
          | keyvalue: commercialInvoiceDetailsOrderCompareFn;
        track invoice.key
      ) {
        <div class="key-value-container">
          <span class="ibc-customer-heading-regular-semibold"
            >{{ renderInvoiceKey(invoice.key) }} :</span
          >
          <span class="ibc-customer-heading-regular">{{ invoice.value }}</span>
        </div>
      }
    </div>
    <div class="shipper-consignee-details">
      @for (details of shipperConsgineeDetails; track details.id) {
        <div class="address-details">
          <div class="header">
            <span class="ibc-customer-heading-regular-semibold">{{
              details.type === 'S' ? 'Shipper' : 'Consignee'
            }}</span>
          </div>
          <div class="content">
            <span *ngIf="details.name" class="ibc-customer-heading-regular"
              >{{ details.name }},</span
            >
            <span class="ibc-customer-heading-regular"
              >{{ details.address_1 ? details.address_1 + ',' : '' }}
              {{ details.address_2 ? details.address_2 + ',' : '' }}
              {{ details.city }}</span
            >
            <span class="ibc-customer-heading-regular"
              >{{ details.state ? details.state + ',' : '' }}
              {{ details.zipCode }}</span
            >
          </div>
        </div>
      }
    </div>
    <div class="invoice-table-container">
      <span class="ibc-customer-heading-regular-semibold">Invoice Total</span>
      <app-summary-table
        [columnDefs]="gridColumnConfig"
        [tableData]="gridData"></app-summary-table>
         <div class="key-value-container">
          <span class="ibc-customer-heading-regular-semibold"
            > Freight : </span
          >
          <span class="ibc-customer-heading-regular">{{ freight }}</span>
        </div>
    </div>
  </div>
</div>
